import { chunk } from 'lodash-es';

import { Flexbox } from '@/ui/flexbox/flexbox';
import { GeneralTag } from '@/ui/tag/general-tag';
import { Tooltip } from '@/ui/tooltip/tooltip';

import { ImpactsEmptyState } from './impacts-empty-state';
import type { CompanyImpact } from '@/api/v4/organization.api';

export const Impacts = ({
  isEditMode = false,
  data,
  emptyStateClickHandler,
}: {
  isEditMode?: boolean;
  data: CompanyImpact[];
  emptyStateClickHandler: () => void;
}) => {
  const [impactsBasic, impactsExtended] = chunk(data, 2);

  const renderBasicImpacts = () =>
    impactsBasic?.map(impact => (
      <GeneralTag key={impact.id} variant="pink">
        {impact.name}
      </GeneralTag>
    ));

  const renderExtendedImpacts = () =>
    impactsExtended?.length ? (
      <Tooltip
        visible
        content={impactsExtended.map(item => item.name).join(', ')}
      >
        <GeneralTag variant="pink">+{impactsExtended.length}</GeneralTag>
      </Tooltip>
    ) : null;

  return (
    <Flexbox name="impacts-container" gap="12px" wrap="wrap">
      {impactsBasic?.length
        ? renderBasicImpacts()
        : isEditMode && <ImpactsEmptyState onClick={emptyStateClickHandler} />}
      {renderExtendedImpacts()}
    </Flexbox>
  );
};
